/**
 * Legenda oficial do MapBiomas Brasil, Coleção 11 (30 m): código do pixel,
 * nome e cor, como em `legend_code_mapbiomas_brazil_collection_11.csv`
 * (brasil.mapbiomas.org/codigos-de-legenda, agosto de 2026). O grupo é o
 * primeiro nível da legenda, para resumir a série.
 */

export type GrupoMapbiomas = 'floresta' | 'campo' | 'agropecuaria' | 'nao-vegetada' | 'agua' | 'desconhecido';

export interface ClasseMapbiomas {
  nome: string;
  cor: string;
  grupo: GrupoMapbiomas;
}

export const MAPBIOMAS_CLASSES: Readonly<Record<number, ClasseMapbiomas>> = {
  3: { nome: 'Formação Florestal', cor: '#1f8d49', grupo: 'floresta' },
  6: { nome: 'Floresta Alagável', cor: '#007785', grupo: 'floresta' },
  4: { nome: 'Formação Savânica', cor: '#7dc975', grupo: 'floresta' },
  7: { nome: 'Savana Alagada', cor: '#228c70', grupo: 'floresta' },
  5: { nome: 'Mangue', cor: '#04381d', grupo: 'floresta' },
  49: { nome: 'Restinga Arbórea', cor: '#02d659', grupo: 'floresta' },
  12: { nome: 'Formação Campestre', cor: '#d6bc74', grupo: 'campo' },
  77: { nome: 'Formação Herbáceo Arbustiva', cor: '#86b074', grupo: 'campo' },
  11: { nome: 'Campo Alagado e Área Pantanosa', cor: '#519799', grupo: 'campo' },
  84: { nome: 'Marismas', cor: '#81dbbf', grupo: 'campo' },
  50: { nome: 'Restinga Herbácea ou Arbustiva', cor: '#ffaa5f', grupo: 'campo' },
  32: { nome: 'Apicum', cor: '#fc8114', grupo: 'campo' },
  29: { nome: 'Afloramento Rochoso', cor: '#ad5100', grupo: 'campo' },
  15: { nome: 'Pastagem', cor: '#edde8e', grupo: 'agropecuaria' },
  39: { nome: 'Soja', cor: '#f5b3c8', grupo: 'agropecuaria' },
  20: { nome: 'Cana', cor: '#db7093', grupo: 'agropecuaria' },
  40: { nome: 'Arroz', cor: '#c71585', grupo: 'agropecuaria' },
  62: { nome: 'Algodão', cor: '#ff69b4', grupo: 'agropecuaria' },
  41: { nome: 'Outras Lavouras Temporárias', cor: '#f54ca9', grupo: 'agropecuaria' },
  46: { nome: 'Café', cor: '#d68fe2', grupo: 'agropecuaria' },
  47: { nome: 'Citrus', cor: '#9932cc', grupo: 'agropecuaria' },
  35: { nome: 'Dendê', cor: '#9065d0', grupo: 'agropecuaria' },
  48: { nome: 'Outras Lavouras Perenes', cor: '#e6ccff', grupo: 'agropecuaria' },
  9: { nome: 'Silvicultura', cor: '#7a5900', grupo: 'agropecuaria' },
  21: { nome: 'Mosaico de Usos', cor: '#ffefc3', grupo: 'agropecuaria' },
  23: { nome: 'Praia, Duna e Areal', cor: '#ffa07a', grupo: 'nao-vegetada' },
  24: { nome: 'Área Urbanizada', cor: '#d4271e', grupo: 'nao-vegetada' },
  30: { nome: 'Mineração', cor: '#9c0027', grupo: 'nao-vegetada' },
  75: { nome: 'Usina Fotovoltaica', cor: '#757272', grupo: 'nao-vegetada' },
  91: { nome: 'Parque Eólico', cor: '#403d3e', grupo: 'nao-vegetada' },
  25: { nome: 'Outras Áreas não Vegetadas', cor: '#db4d4f', grupo: 'nao-vegetada' },
  33: { nome: 'Rio, Lago e Oceano', cor: '#2532e4', grupo: 'agua' },
  31: { nome: 'Aquicultura', cor: '#091077', grupo: 'agua' },
};

/** Código fora da legenda (coleção nova com classe nova): cinza, sem quebrar. */
export function classeMapbiomas(codigo: number): ClasseMapbiomas {
  return MAPBIOMAS_CLASSES[codigo] ?? { nome: `Classe ${codigo}`, cor: '#8a8f98', grupo: 'desconhecido' };
}

export const MAPBIOMAS_URL = 'https://brasil.mapbiomas.org/';
